import ReactGA from "react-ga4";

const TRACKING_ID = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;

export const initGA = () => {
  if (TRACKING_ID) {
    ReactGA.initialize(TRACKING_ID);
  } else {
    console.error("Google Analytics ID is missing.");
  }
};

export const logPageView = (path) => {
  if (TRACKING_ID) ReactGA.send({ hitType: "pageview", page: path });
  if (/^\/(admin|manager|employee|api)(\/|$)/i.test(path)) return;
  // Store aggregate page counts without visitor identifiers or query strings.
  fetch("/api/analytics/page-view", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ path }),
    keepalive: true,
  }).catch(() => {}); // Analytics must never interrupt navigation.
};

export const logEvent = (name, properties = {}) => {
  if (!TRACKING_ID || !name) return;
  ReactGA.event(name, properties);
};
